import { Button, Container, Dialog, DialogActions, DialogContent, Grid, makeStyles } from "@material-ui/core";
import React, { FC } from "react";
import TranslatedMessage from "../translations/TranslatedMessage";
import Form from "../startCertificationWizard_new/components/shared/Form";
import { useUpdateMeMutation } from "../../api/rtk/MeApi";
import { CandidateViewModel } from "../../model/CandidateViewModel";
import { useIntl } from "react-intl";
import { getSchema } from "../startCertificationWizard_new/components/Step1_PersonalData/PersonalDataStepSchema";
import LifeCandidateFields from "./LifeCandidateFields";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { ObjectHelper } from "../../utils/ObjectHelper";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
  },
  dialogContent: {
    padding: theme.spacing(8),
  },
}));

type LifePersonalDataDialogProps = {
  me: CandidateViewModel;
  show: boolean;
  handleSuccess: () => void;
  handleCancel: () => void;
};

const LifePersonalDataDialog: FC<LifePersonalDataDialogProps> = ({ me, show, handleSuccess, handleCancel }) => {
  const intl = useIntl();
  const classes = useStyles();
  const [updateMe, { isLoading: isUpdatingMe }] = useUpdateMeMutation();

  const onSubmit = async (data: CandidateViewModel): Promise<void> => {
    if (data && !isUpdatingMe) {
      if (!ObjectHelper.hasEquivalentData(data, me, ["preferredContact"])) {
        var response = await updateMe({
          ...data,
          placeOfOrigin: !data.nationalityIsSwiss ? data.homeCountry : data.placeOfOrigin,
          disablePersonalFields: true,
        }).unwrap();
        if (response.success) {
          handleSuccess();
        }
      } else {
        handleSuccess();
      }
    }
  };

  return (
    <Dialog fullWidth={true} maxWidth="md" open={!!show} disableBackdropClick={true}>
      <Form onSubmit={onSubmit} defaultValues={me} schema={getSchema(intl)}>
        <DialogContent className={classes.dialogContent}>
          <Container className={classes.container}>
            <Grid container={true} direction="column" spacing={2}>
              <LifeCandidateFields candidate={me} />
            </Grid>
          </Container>
        </DialogContent>
        <DialogActions>
          {isUpdatingMe && <LoadingSpinner />}
          <Button onClick={handleCancel} variant="contained" color="secondary" disabled={isUpdatingMe}>
            <TranslatedMessage id="common.cancel" />
          </Button>
          <Button variant="contained" color="primary" type="submit" disabled={isUpdatingMe}>
            <TranslatedMessage id="common.save" />
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default LifePersonalDataDialog;
